import store from '../helpers/store';
import { clientUrls } from '../sandbox/const/clients';
export var accountIdType = 'guid';
var NODE_ENV = process.env.NODE_ENV;
var APP_ENV = 'CF_APP_ENV';
var BASENAME = '/creditbalancerefund';
var QA_URL = 'https://qa.synchronycredit.com';
export var setTargetOrigin = function (environment, client) {
    var currentClient = client !== null && client !== void 0 ? client : store.get('client', 'session');
    return ((environment === 'production' && clientUrls[currentClient]) ||
        QA_URL);
};
var prodConfig = {
    API_HOST: 'CF_API_HOST',
    APP_ENV: APP_ENV,
    ASSETS_HOST: 'CF_ASSETS_HOST',
    AUTH_DOMAIN: 'CF_AUTH_DOMAIN',
    BASENAME: 'CF_BASENAME',
    PSCC_APIGEE_CLIENT_ID: 'CF_PSCC_APIGEE_CLIENT_ID',
    PSCC_URL: 'CF_PSCC_URL',
    RC_APIGEE_CLIENT_ID: 'CF_RC_APIGEE_CLIENT_ID',
    TARGET_ORIGIN: 'CF_ASSETS_HOST',
    UNIVERSAL_APIGEE_CLIENT_ID: 'CF_UNIVERSAL_APIGEE_CLIENT_ID'
};
var localConfig = {
    API_HOST: 'https://api-qa.syf.com',
    APP_ENV: 'local',
    ASSETS_HOST: QA_URL,
    AUTH_DOMAIN: 'https://auth-qa.syf.com',
    BASENAME: BASENAME,
    PSCC_APIGEE_CLIENT_ID: 'u7mG6G45NuwHi9Ul1YpMX1zC9zV6YPJQ',
    PSCC_URL: 'https://q3consumercenter.mysynchrony.com/consumercenter',
    RC_APIGEE_CLIENT_ID: 'U4AxK9CbSaWREyi88qlFl3BNLpXF21Ba',
    TARGET_ORIGIN: QA_URL,
    UNIVERSAL_APIGEE_CLIENT_ID: 'G0aFAZvPHNurZSUSJ1RGMcb5FebcSWjr'
};
if (prodConfig.BASENAME === 'CF_BASENAME')
    prodConfig.BASENAME = BASENAME;
export default NODE_ENV === 'production' ? prodConfig : localConfig;
